export const RESOURCES_PATH = '/resources'
export const P2IA_PATH = '/p2ia'
export const TEAM_PATH = '/team'
export const PRICING_PATH = '/pricing'
export const LEARN_MORE_PATH = '/learn-more'
export const REQUEST_A_QUOTE_PATH = '/request-a-quote'
